exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cust-sticky[data-v-620f134f]{position:-webkit-sticky;position:sticky;top:75px!important;z-index:99}.header[data-v-620f134f]{position:relative;overflow:hidden;height:2.6rem;line-height:2.6rem;text-align:center;background-color:#fff;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.header .header-back[data-v-620f134f]{left:0}.header .header-act[data-v-620f134f],.header .header-back[data-v-620f134f]{position:absolute;top:0;width:2.6rem;font-size:1.2rem;text-align:center}.header .header-act[data-v-620f134f]{right:0}", ""]);

// exports
